import React, { useState } from "react";

const DetallesPerfil = () => {
  const [userDetails, setUserDetails] = useState({
    nombre: "Lorenzo",
    apellidos: "Picado Campos",
    correo: "hoyvemos.com@gmail.com",
    username: "HVLorenzoPi",
    fechaNacimiento: "1988-06-15",
    telefono: "+506 8888-8888",
  });

  return (
    <div className="bg-white shadow sm:rounded-lg p-6">
      <h3 className="text-lg font-medium leading-6 text-gray-900">Detalles del Perfil</h3>
      <p className="mt-1 text-sm text-gray-600">Edita tu información personal</p>

      <div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
        {/* Nombre */}
        <div className="sm:col-span-3">
          <label htmlFor="nombre" className="block text-sm font-medium text-gray-700">
            Nombre
          </label>
          <input
            type="text"
            name="nombre"
            id="nombre"
            value={userDetails.nombre}
            onChange={(e) => setUserDetails({ ...userDetails, nombre: e.target.value })}
            className="mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
          />
        </div>

        {/* Apellidos */}
        <div className="sm:col-span-3">
          <label htmlFor="apellidos" className="block text-sm font-medium text-gray-700">
            Apellidos
          </label>
          <input
            type="text"
            name="apellidos"
            id="apellidos"
            value={userDetails.apellidos}
            onChange={(e) => setUserDetails({ ...userDetails, apellidos: e.target.value })}
            className="mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
          />
        </div>

        {/* Correo */}
        <div className="sm:col-span-4">
          <label htmlFor="correo" className="block text-sm font-medium text-gray-700">
            Correo Electrónico
          </label>
          <input
            type="email"
            name="correo"
            id="correo"
            value={userDetails.correo}
            onChange={(e) => setUserDetails({ ...userDetails, correo: e.target.value })}
            className="mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
          />
        </div>

        {/* Username */}
        <div className="sm:col-span-2">
          <label htmlFor="username" className="block text-sm font-medium text-gray-700">
            Nombre de Usuario
          </label>
          <input
            type="text"
            name="username"
            id="username"
            value={userDetails.username}
            className="mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
            disabled
          />
        </div>

        {/* Fecha de Nacimiento */}
        <div className="sm:col-span-3">
          <label htmlFor="fechaNacimiento" className="block text-sm font-medium text-gray-700">
            Fecha de Nacimiento
          </label>
          <input
            type="date"
            name="fechaNacimiento"
            id="fechaNacimiento"
            value={userDetails.fechaNacimiento}
            onChange={(e) => setUserDetails({ ...userDetails, fechaNacimiento: e.target.value })}
            className="mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
          />
        </div>

        {/* Teléfono */}
        <div className="sm:col-span-3">
          <label htmlFor="telefono" className="block text-sm font-medium text-gray-700">
            Teléfono
          </label>
          <input
            type="tel"
            name="telefono"
            id="telefono"
            value={userDetails.telefono}
            onChange={(e) => setUserDetails({ ...userDetails, telefono: e.target.value })}
            className="mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
          />
        </div>
      </div>

      {/* Cambiar Contraseña */}
      <div className="mt-6">
        <label htmlFor="password" className="block text-sm font-medium text-gray-700">
          Cambiar Contraseña
        </label>
        <input
          type="password"
          name="password"
          id="password"
          placeholder="Nueva contraseña"
          className="mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
        />
      </div>

      <div className="mt-6 flex justify-end">
        <button
          type="button"
          className="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700"
        >
          Guardar Cambios
        </button>
      </div>
    </div>
  );
};

export default DetallesPerfil;
